import React from 'react';
import Select from '../../Basic/Select';
import SectionHeader from '../../Basic/SectionHeader';
const GasDeliveryPressure = ({ address }) => {
    const lookup = window.osa.lookup.projectSpecifics.gasDeliveryPressure;
    const title = (address && address.toLowerCase().indexOf('revelstoke') >=0 ) ?  lookup.titleRevelstoke : lookup.title;
  
    return (
        <div>
                  <div className="row">
                <div className="col-sm-12">
                   <SectionHeader title={title} />
                </div>
            </div>
         
            <div className="row">
                <div className="col-sm-12 col-md-4">
                    <Select name="gasDeliveryPressure" items={ address && address.toLowerCase().indexOf('revelstoke') >=0 ? lookup.itemsRevelstoke : lookup.items}  />
                </div>
            </div>
                <div className="row">
                        <div className="col-sm-12">
                            <h4 className=" text-primary"><span>If needed, you can request a different delivery pressure.  If you are not sure what is right for you, talk to your contractor.</span></h4>
                        </div>
                    </div>
        </div>
    );
};
GasDeliveryPressure.propTypes = {
    differentDeliveryPressure: React.PropTypes.string
};
export default GasDeliveryPressure;